"use strict";

var EPK = EPK || {};
EPK.Shoho = EPK.Shoho || {};

var args = {
	urlExecute: '',
	urlFinish: '',
	reserveBundleId: '',
	reserveIds: [],
	pharmacyId: '',
	webtofax: '',
	memberFlag: '',
	pastReserveStatus: '',
	optinMailmag: '',
};
EPK.Shoho.ARG = EPK.Shoho.ARG || args;

EPK.Shoho.Reserve = function( urlExecute, urlFinish, reserveBundleId, reserveIds, pharmacyId, memberFlag, pastReserveStatus, optinMailmag ) {
	this.urlExecute = urlExecute;
	this.urlFinish = urlFinish;
	this.reserveBundleId = reserveBundleId;
	this.reserveIds = reserveIds;
	this.pharmacyId = pharmacyId;
	this.uploadResult = true;
	this.uploadResultMessage = "";
	this.memberFlag = memberFlag;
	this.executeFlag = true;
	this.pastReserveStatus = pastReserveStatus;
	this.optinMailmag = optinMailmag;
};

EPK.Shoho.Reserve.prototype.execute = function() {
	this.request(this.reserveIds.shift());
};

EPK.Shoho.Reserve.prototype.request = function( elem ) {

	if ( !elem ) {
		// 会員予約でエラーがなければ会員情報連携
		if (this.memberFlag && this.executeFlag) {
			this.updateEparkMemberInfo(this.optinMailmag);
		}

		var urlFinish = EPK.Shoho.ARG.urlFinish;
		if (!this.memberFlag && this.executeFlag) {
			urlFinish += '&' + this.pastReserveStatus;
		}

		location.href = urlFinish;
		return;
	}
	var _this = this;

	this.changeStatus( elem.personType , 'progress' );
	var request = $.ajax(
		{
			type: "GET",
			url: this.urlExecute,
			cache: false,
			data: {
				reserve_bundle_id: elem.reserveBundleId,
				mw_reserve_id: elem.mwReserveId,
				person_type: elem.personType
			}
		}
	).done(
		function(data) {
			_this.changeStatus( elem.personType , 'complete' );
			_this.request(_this.reserveIds.shift());
		}
	).fail(
		function(data) {
			_this.changeStatus( elem.personType , 'error' );
			_this.request(_this.reserveIds.shift());
		}
	);
};

EPK.Shoho.Reserve.prototype.changeStatus = function ( person_type  , status ) {
	var elemPerson = $('#' + person_type );
	var elemStatus = $('#' + person_type ).find(".status");
	var elemStatusLabel = $('#' + person_type ).find(".status_label");
	var loading = $('#' + person_type ).find(".shoho_loading");

	switch (status){
		case 'error':
			elemStatus.text("が送信エラー");
			elemStatusLabel.text("送信エラー");
			elemStatusLabel.addClass('error');
			elemStatusLabel.removeClass('processed');
			loading.remove(0);
			this.executeFlag = false;
			break;
		case 'progress':
			elemStatus.text("を送信中");
			elemStatusLabel.text("処理中");
			elemStatusLabel.addClass('processed');
			elemStatusLabel.removeClass('wait');
			break;
		case 'complete':
			elemStatus.text("を送信完了");
			elemStatusLabel.text("完了");
			elemStatusLabel.addClass('complete');
			elemStatusLabel.removeClass('processed');
			loading.remove(0);
			break;
	}
};

EPK.Shoho.Reserve.prototype.redirect = function() {
	var url = this.urlFinish + "?reserve_bundle_id=" + this.reserveBundleId + "&pharmacy_id=" + this.pharmacyId;
	$(location).attr("href", url);
};

EPK.Shoho.Reserve.prototype.updateEparkMemberInfo = function(optinMailmag) {
	// optinMailmag == 2 は実行しない
	if (optinMailmag != 2) {
		var url = '/api/member/update/shoho_optin';
		$.ajax({
			type: 'GET',
			url: url,
			data: {optin: optinMailmag},
			cache: false
		});
	}
};

EPK.Shoho.FileUploader = function(pharmacyId, webtofax) {
	this.pharmacyId = pharmacyId;
	this.isProcessing = false;
	this.array = new Array();
	this.webtofax = webtofax;
};

EPK.Shoho.FileUploader.prototype.initialize = function(pharmacyId) {
	this.photograph();
};

EPK.Shoho.FileUploader.prototype.togglePreviewElements = function () {
	var _this = this;
	$(EPK.Shoho.PersonTypes).each(function(index) {
		_this.togglePersonType(this.id);
	});
};

// コメントアウト追加
EPK.Shoho.FileUploader.prototype.togglePersonType = function (person_type) {
	this.photograph();
	var person_type_id = "#" + person_type;
	var $person_element = $(person_type_id);

	var isBeforeElementShowAddButton = false;
	var isImage = 0;
	var isChangeVisible = false;
	var $btnAdd = $person_element.find("label");
	$person_element.find("td[id ^= list]").each(function(index) {
		var $btnPreview = $(this);
		if ( $btnPreview.find('a').data("image-uploaded") ) {
			$btnPreview.show();
			$btnPreview.find('a').show();
			isImage++;
			isBeforeElementShowAddButton = false;
		} else {
			if ( isBeforeElementShowAddButton == false ) {
				// 処方箋画像アップラベル切り替え
				if (isChangeVisible == false) {
					var id_split = $(this).attr("id").split('-');
					var id_attr = id_split[1] + '-' + id_split[2] + '-picture';
					$btnAdd.attr("for", id_attr);
					$btnAdd.removeClass();
					isChangeVisible = true;
				}
			}
			isBeforeElementShowAddButton = true;
		}
	});

	// 処方箋画像アップラベル表示切り替え
	if (isImage < 5) {
		$btnAdd.parent().show();
	} else {
		$btnAdd.parent().hide();
	}

	var elCount = 0;
	$person_element.find('td').each(function(index, el) {
		if ($(el).css('display') != 'none') {
			elCount++;
		}
	});
	$btnAdd.addClass('label-'+person_type+'-'+elCount);
};

EPK.Shoho.FileUploader.prototype.bindPreviewClose = function() {
	$(".btn-closePreview").on("click",function(event){
		$(event.target).parents().find(".modalPreviewImage").remove(0);
	});
};

// 処方箋画像が選択された際の処理
EPK.Shoho.FileUploader.prototype.changeSave = function() {
	var _this = this;
	$(".form-fileShoho").on("change",function(event){
		var $target = $(event.target);
		var personType = $target.data("person-type");
		var $messageArea = $(".js-error-message");
		$messageArea.text("");
		if (_this.checkTargetCompressed()) {
			_this.afterImageSelectedCompressed(event);
		} else {
			_this.afterImageSelected(event);
		}
	});
};

EPK.Shoho.FileUploader.prototype.bindPreviewEvent = function() {
	var _this = this;

	$(".btn-showPreviewImage").on("click",function(event){
		var $target = $(event.target);
		var shopId = $target.data("shop-id");
		var personType = $target.data("person-type");
		var imageIndex = $target.data("image-index");

		// preview リンクを表示する。
		var preview_link = "/shoho/image?pharmacy_id="+shopId+"&person_type="+personType+"&index="+imageIndex+"&ver="+new Date().getTime();
		var args = {person_type: personType,index: imageIndex ,preview_link: preview_link, shop_id: shopId};
		var rendered = $("#modalImagePreview").render(args);
		var elem = $(rendered);
		$(".mfp-content").prepend(elem);
		$(".mfp-s-error .mfp-content").css('display', 'inline-block');
		_this.bindPreviewClose();
		_this.bindDeleteEvent();
	});
};

EPK.Shoho.FileUploader.prototype.upload_compressed = function($complessed_img, personType,index,shopId,$list) {
	var _this = this;
	var $fileForm = $("#"+ personType + "-" + index + "-picture");

	if (personType.indexOf('hospital') == -1){
		var child_name = "child_member_no_" + personType;
	}else{
		var child_name = "child_member_no_" + personType.replace('hospital', 'shoho');
	}
	var family_no = $('[name= ' + child_name + ']').val();
	var uploadUrl = $fileForm.data("upload-url") + '&js_file_resize=1&webtofax=' + this.webtofax + '&family_no=' + family_no;
	var $messageArea = $(".js-error-message");

	if ( !uploadUrl ) {
		return;
	}
	if ( $fileForm.prop("files").length == 0 ) {
		return true;
	}
	var formData = new FormData();
	formData.append($fileForm.prop("name"), $complessed_img);
	var postData = {
		type : "POST",
		dataType : "json",
		data : formData,
		processData : false,
		contentType : false,
		context: $fileForm
	};

	$.ajax(uploadUrl, postData)
		.done(function(data, textStatus, jqXHR){
			$(this).val("");
			_this.uploadResult = data.result;
			_this.uploadResultMessage = data.error_message;

			var img = new Image();
			if (_this.uploadResult) {
				$list.find('a').removeClass('thumbloading');
				$list.find('a').addClass('checkimg');
				if($('#shown_thumbnail_images_count').length > 0){
					shownThumbnailImagesCounter.increaseShownImagesCount(personType);
				}
			} else {
				_this.deleted(personType, index, shopId, $fileForm);
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown){
			_this.uploadResult = false;
			_this.uploadResultMessage = "アップロード中にサーバーエラーが発生しました。";
			_this.deleted(personType, index, shopId, $fileForm);
		})
		.always(function() {
			$list.find('a').removeClass('thumbloading');
			$messageArea.first().text(_this.uploadResultMessage);
			_this.stack();
		});
};


EPK.Shoho.FileUploader.prototype.upload = function(personType,index,shopId,$list) {
	var _this = this;
	var $form = $("#form-input-"+ personType + "-" + index);
	var $fileForm = $("#"+ personType + "-" + index + "-picture");
	var uploadUrl = $fileForm.data("upload-url") + '&js_file_resize=0&webtofax=' + this.webtofax;
	var $messageArea = $(".js-error-message");
	if ( !uploadUrl ) {
		return;
	}
	if ( $fileForm.prop("files").length == 0 ) {
		return true;
	}
	var formData = new FormData();
	formData.append($fileForm.prop("name"),$fileForm.prop("files")[0]);
	var postData = {
//		async: false,
		type : "POST",
		dataType : "json",
		data : formData,
		processData : false,
		contentType : false,
		context: $fileForm
	};

	$.ajax(uploadUrl, postData)
		.done(function(data, textStatus, jqXHR){
			$(this).val("");

			_this.uploadResult = data.result;
			_this.uploadResultMessage = data.error_message;

			var img = new Image();
			if (_this.uploadResult) {
				$list.find('a').removeClass('thumbloading');
				$list.find('a').addClass('checkimg');
				if($('#shown_thumbnail_images_count').length > 0){
					shownThumbnailImagesCounter.increaseShownImagesCount(personType);
				}
			} else {
				_this.deleted(personType, index, shopId, $fileForm);
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown){
			_this.uploadResult = false;
			_this.uploadResultMessage = "アップロード中にサーバーエラーが発生しました。";
			_this.deleted(personType, index, shopId, $fileForm);
		})
		.always(function() {
			$list.find('a').removeClass('thumbloading');
			$messageArea.first().text(_this.uploadResultMessage);
			_this.stack();
		});
};

EPK.Shoho.FileUploader.prototype.uploadFile = function() {
	$(".btn-closePreview").on("click",function(event){
		$(event.target).parents().find(".modalPreviewImage").remove(0);
	});
};

EPK.Shoho.FileUploader.prototype.deleted = function(personType,index,shopId,$target) {
	var _this = this;

	$.ajax({
		type: "GET",
		url: "/shoho/image",
		cache: false,
		timeout: 20000,
		data: {
			pharmacy_id: shopId,
			person_type: personType,
			index: index,
			command: 'delete'
		},
		context:$target
	}).done(function(data, textStatus, jqXHR){
		_this.afterImageDeleted($target);
	}).fail(function(jqXHR, textStatus, errorThrown){
	}).always(function() {
		_this.stack();
	});
}

EPK.Shoho.FileUploader.prototype.bindDeleteEvent = function() {
	var _this = this;
	$(".btn-deleteImage").on("click",function(event){
		var $target = $(event.target);
		var shopId = $target.data("shop-id");
		var personType = $target.data("person-type");
		var imageIndex = $target.data("image-index");

		if (!_this.isProcessing) {
			_this.changeBtnProp(true, '画像処理中です...');
			_this.isProcessing = true;
			_this.deleted(personType,imageIndex,shopId,$target);
		} else {
			_this.array.push(['delete',personType,imageIndex,shopId,$target]);
		}
	});
};

// 処方箋画像追加
EPK.Shoho.FileUploader.prototype.afterImageSelected = function (event) {
	var personType = $(event.target).data("person-type");
	var shopId = $(event.target).data("shop-id");
	var $picture_check_element = $('#' + personType);
	var imageIndex = $(event.target).data("image-index");
	var $list = $("#list-" + personType + "-" + imageIndex);

	var $messageArea = $(".js-error-message");
	$messageArea.text("");

	$list.find('a').addClass('thumbloading');
	$list.find('a').removeClass('checkimg');
	$list.find("a").data("image-uploaded",1);
	$list.show();
	$('#' + personType).removeClass('hidden');

	if (!this.isProcessing) {
		this.changeBtnProp(true, '画像処理中です...');
		this.isProcessing = true;
		this.upload(personType,imageIndex,shopId,$list);
	} else {
		this.array.push(['upload',personType,imageIndex,shopId,$list]);
	}

	var image_count = $picture_check_element.data("image-count");
	image_count = image_count + 1;
	$picture_check_element.data("image-count",image_count);

	this.togglePersonType(personType);
};

EPK.Shoho.FileUploader.prototype.afterImageSelectedCompressed = function (event) {
	var file = event.currentTarget.files[0];
	var size = file.size;
	var type = file.type;
	var filename = file.name;
	var _this = this;

	var dataUrl = URL.createObjectURL(file);
	var image = new Image();
	image.onload = function(){
		var width = image.width;
		var height = image.height;
		var canvasWidth;
		var canvasHeight;
		var longSide = _this.webtofax == 0 ? 2500 : 2500;

		EPK.Shoho.widthheight = EPK.utils.getUrlParam('max') || longSide;

		if(height > width){
			canvasHeight = EPK.Shoho.widthheight;
			canvasWidth = width * EPK.Shoho.widthheight / image.height;
		}else{
			canvasWidth = EPK.Shoho.widthheight;
			canvasHeight = height * EPK.Shoho.widthheight / image.width;
		}

		var $canvas = $('<canvas></canvas>');
		var canvas = $canvas[0];
		canvas.width = canvasWidth;
		canvas.height = canvasHeight;

		var ctx = canvas.getContext('2d');
		ctx.drawImage( image , 0, 0, width, height, 0, 0, canvasWidth, canvasHeight);
		var base64 = canvas.toDataURL("image/jpeg");

		var personType = $(event.target).data("person-type");
		var shopId = $(event.target).data("shop-id");
		var $picture_check_element = $("#" + personType);
		var imageIndex = $(event.target).data("image-index");
		var $list = $("#list-" + personType + "-" + imageIndex);

		var $messageArea = $(".js-error-message");
		$messageArea.text("");

		$list.find('a').addClass('thumbloading');
		$list.find('a').removeClass('checkimg');
		$list.find("a").data("image-uploaded",1);
		$list.show();
		$('#' + personType).removeClass('hidden');

		if (!this.isProcessing) {
			this.changeBtnProp(true, '画像処理中です...');
			this.isProcessing = true;
			this.upload_compressed(base64, personType,imageIndex,shopId,$list);
		} else {
			this.array.push(['upload_comp',personType,imageIndex,shopId,$list,base64]);
		}

		var image_count = $picture_check_element.data("image-count");
		image_count = image_count + 1;
		$picture_check_element.data("image-count",image_count);

		this.togglePersonType(personType);

	}.bind(this);
	image.src = dataUrl;
}

// 処方箋画像削除
EPK.Shoho.FileUploader.prototype.afterImageDeleted = function($target) {
	var person_type = $target.data("person-type");
	var $picture_check_element = $("#" + person_type);
	var index = $target.data("image-index");
	var $list = $("#list-" + person_type + "-" + index);
	var $modal = $("#modal-" + person_type + "-" + index);

	$list.hide();
	$list.find("a").data("image-uploaded",0);
	$modal.remove(0);

	var image_count = $picture_check_element.data("image-count");
	image_count = image_count - 1;
	$picture_check_element.data("image-count", image_count);

	this.togglePersonType(person_type);

	if($('#shown_thumbnail_images_count').length > 0){
		shownThumbnailImagesCounter.decreaseShownImagesCount(person_type);
	}
};

// 処方箋ボタンアイコン表示切り替え制御
EPK.Shoho.FileUploader.prototype.photograph = function() {
	var count = 0;
	$(".picture-check").each(function(index) {
		var $class = '.label-' + $(this).attr("id");
		if ( $(this).data("image-count") == 0 ) {
			$(this).hide();
			$(".shoho-picture-up").show();
			$(".shoho-picture-up").find($class).parent().show();
		} else {
			$(".shoho-picture-up").find($class).parent().hide();
			$(this).show();
			count++;
		}
	});
	if (count == EPK.Shoho.PersonTypes.length){
		$(".shoho-picture-up").hide();
	} else {
		$(".shoho-picture-up").show();
	}
};

EPK.Shoho.FileUploader.prototype.initializeInConfirm = function(pharmacyId) {
	$(".picture-check").show();
};

// 処方箋画像カウント処理
EPK.Shoho.FileUploader.prototype.countStyleDisp = function() {
	var shown_thumbnail_images_count = $("#shown_thumbnail_images_count").val();
	var json_data = JSON.parse(shown_thumbnail_images_count);
	var family_kinds = [['self01', 'self01shoho', 'self01hospital'],
						['family01', 'family01shoho', 'family01hospital'],
						['family02', 'family02shoho', 'family02hospital']];
	var result = true;
	$.each(family_kinds, function(index,family_kind) {
		if (family_kind[1] in json_data === false && family_kind[2] in json_data === false && $('#patientselect-box-' + family_kind[1]).css('display') != 'none'){
			result = false;
		}
	});
	return result;	
}

// 処方箋画像処理中の確認画面遷移ボタン制御
EPK.Shoho.FileUploader.prototype.changeBtnProp = function(bool, text) {
	if (text == undefined) {
		text = '上記に同意して進む';
	}
	$('.res-send-button .reserve-popup-send').children('input[type="button"], input[type="submit"]').prop("disabled", bool);
	$('.res-send-button .reserve-popup-send').children('input[type="button"], input[type="submit"]').val(text);
}

//処方箋画像を順次実行
EPK.Shoho.FileUploader.prototype.stack = function() {
	if (this.array[0] != undefined &&
		(this.array.length > 0 || !this.isProcessing)) {
		var args = this.array.shift();
		if (args[0] === 'upload') {
			this.upload(args[1],args[2],args[3],args[4]);
		} else if (args[0] === 'upload_comp') {
			this.upload_compressed(args[5],args[1],args[2],args[3],args[4]);
		} else if(args[0] === 'delete') {
			this.deleted(args[1],args[2],args[3],args[4]);
		}
	} else {
		if (!this.countStyleDisp()) {
			this.changeBtnProp(true, '登録した画像は0枚です');
		} else {
			this.changeBtnProp(false, '上記に同意して進む');
		}

		this.isProcessing = false;
	}
}

EPK.Shoho.FileUploader.prototype.checkTargetCompressed = function() {
	var fileResult = false;
	var urlResult = false;
	var targetPathResult = false;
	var targetPaths = new Array('/shoho/prescription', '/shoho/retry');

	if (window.File) {
		fileResult = true;
	} else {
		fileResult = false;
	}

	if (window.URL) {
		urlResult = true;
	} else {
		urlResult = false;
	}

	if ($.inArray(location.pathname, targetPaths) > -1) {
		targetPathResult = true;
	} else {
		targetPathResult = false;
	}

	return fileResult && urlResult && targetPathResult;
};

EPK.Shoho.GuestSignup = function() {};

EPK.Shoho.GuestSignup.prototype.moveToSignup = function () {
	$("#eparkSignupShoho").submit();
};

EPK.Shoho.showBookmarkLogin = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-bookmark-require-login'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.Shoho.saveBookmark = function () {
	var $form = $("#form-Bookmark");
	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		data: {"op": "add"},
		cache: false,
		dataType : "json"
	}).done(function(data, textStatus, jqXHR){

		console.log(data);

		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-bookmark-complete'},
			type: 'inline',
			modal: true
		}, 0);
		$("#btn-addBookmark").hide();
		$("#btn-deleteBookmarkConfirm").show();

	}).fail( function(data) {
		console.log("shop like fail");
        $.magnificPopup.open({
            items: {src: "#modal-bookmark-submit-fail"},
            type: 'inline',
            modal: true
        }, 0);
	});
};

EPK.Shoho.showConfirmDeleteBookmark = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-bookmark-delete-confirm'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.Shoho.deleteBookmark = function () {
	var $form = $("#form-Bookmark");
	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		data: {"op": "delete"},
		cache: false,
		dataType : "json"
	}).done(function(data, textStatus, jqXHR){
		console.log(data);

		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-bookmark-delete-complete'},
			type: 'inline',
			modal: true
		}, 0);
		$("#btn-addBookmark").show();
		$("#btn-deleteBookmarkConfirm").hide();

	}).fail( function(data) {
		console.log("shop like fail");
        $.magnificPopup.open({
            items: {src: "#modal-bookmark-delete-fail"},
            type: 'inline',
            modal: true
        }, 0);
	});
};

EPK.Shoho.Payment = function() {
	this.isLoad = false;
	this.status = 0;	// 0:初期 1:取得成功 2:取得エラー 3:未登録 4:想定外エラー

	EPK.Shoho.Payment.$cardChangeBtn = $('.res-card-change-btn');
	EPK.Shoho.Payment.$cardError = $('.res-card-error');
	EPK.Shoho.Payment.$creditBox = $('.res-credit-box');
	EPK.Shoho.Payment.$creditBoxText = $('.res-credit-box-text');
	EPK.Shoho.Payment.$creditBtnSub = $('.res-ceredit-btn-sub');
	EPK.Shoho.Payment.$creditCheck = $('.res-credit-check');
	EPK.Shoho.Payment.$creditInfo = $('#credit-info');
	EPK.Shoho.Payment.$creditLoading = $('#credit-loading');
	EPK.Shoho.Payment.$sendCreditcard = $('.res-send-creditcard');
	EPK.Shoho.Payment.$creditValueNumber = $('#credit-number');
	EPK.Shoho.Payment.$creditValueType = $('#credit-type');
	EPK.Shoho.Payment.$creditValueDate = $('#credit-date');
	EPK.Shoho.Payment.$creditValueNumberHdn = $('input[name="credit-number"]');
	EPK.Shoho.Payment.$creditValueTypeHdn = $('input[name="credit-type"]');
	EPK.Shoho.Payment.$creditValueDateHdn = $('input[name="credit-date"]');
}

EPK.Shoho.Payment.prototype.getCardInformation = function() {
	var _this = this;

	if (this.isLoad) {
		EPK.Shoho.Payment.$creditCheck.show();
	} else {
		EPK.Shoho.Payment.$creditInfo.hide();
		EPK.Shoho.Payment.$creditBoxText.hide();
		EPK.Shoho.Payment.$sendCreditcard.hide();
		EPK.Shoho.Payment.$cardChangeBtn.hide();
		EPK.Shoho.Payment.$creditBtnSub.hide();
		EPK.Shoho.Payment.$cardError.hide();
		EPK.Shoho.Payment.$creditCheck.show();
		EPK.Shoho.Payment.$creditLoading.show();

		this.executeAjax();
	}
}

EPK.Shoho.Payment.prototype.executeAjax = function() {
	var _this = this
	var url = '/api/shoho/getCardInfo';

	$.ajax({
		url: url,
		type: 'GET',
		dataType : 'json',
		cache: false
	})
	.done(function(data, textStatus, jqXHR) {
		EPK.Shoho.Payment.$creditLoading.hide();

		if (data.status == 0 || data.status == 2) {
			// クレカ情報取得成功
			$.each(data, function(key, val) {
				if ($.isPlainObject(val)) {
					$.each(val, function(key2, val2) {
						if (key2 == 'cardNumber') {
							EPK.Shoho.Payment.$creditValueNumber.html(val2);
						} else if (key2 == 'cardType') {
							EPK.Shoho.Payment.$creditValueType.html(val2);
						} else if (key2 == 'expireDate') {
							EPK.Shoho.Payment.$creditValueDate.html(val2.slice(0, 2) + '/' + val2.slice(2));
						}
					});
				}
			});

			if (data.status == 2) {
				EPK.Shoho.Payment.$creditBox.addClass('credit-info-error');
				EPK.Shoho.Payment.$creditBoxText.text('VISA・MASTER以外はご利用になれません');
				EPK.Shoho.Payment.$creditBox.show();
				EPK.Shoho.Payment.$creditBoxText.show();
			}

			EPK.Shoho.Payment.$creditInfo.show();
			EPK.Shoho.Payment.$cardChangeBtn.show();
			EPK.Shoho.Payment.$creditBtnSub.show();

			_this.status = 1;
		} else {
			if (data.errors.code == 1009) {
				// クレカ情報未登録
				EPK.Shoho.Payment.$creditBoxText.text('クレジットカードが登録されていません。');
				EPK.Shoho.Payment.$creditBoxText.show();
				EPK.Shoho.Payment.$sendCreditcard.show();
				EPK.Shoho.Payment.$creditBtnSub.show();

				_this.status = 3;
			} else {
				EPK.Shoho.Payment.$cardError.show();
				EPK.Shoho.Payment.$creditInfo.show();

				_this.status = 2;
			}
		}
	})
	.fail(function(data) {
		EPK.Shoho.Payment.$creditLoading.hide();
		EPK.Shoho.Payment.$cardError.show();
		EPK.Shoho.Payment.$creditInfo.show();
		console.log('get credit card information failed');

		_this.status = 4;
	})
	.always(function() {
		_this.isLoad = true;

		if (_this.status == 1) {
			EPK.Shoho.Payment.$creditValueNumberHdn.val(EPK.Shoho.Payment.$creditValueNumber.text());
			EPK.Shoho.Payment.$creditValueTypeHdn.val(EPK.Shoho.Payment.$creditValueType.text());
			EPK.Shoho.Payment.$creditValueDateHdn.val(EPK.Shoho.Payment.$creditValueDate.text());
		} else if (_this.status == 3) {
			EPK.Shoho.Payment.$creditValueNumberHdn.val('unregister');
			EPK.Shoho.Payment.$creditValueTypeHdn.val('unregister');
			EPK.Shoho.Payment.$creditValueDateHdn.val('unregister');
		} else {
			EPK.Shoho.Payment.$creditValueNumberHdn.val('error');
			EPK.Shoho.Payment.$creditValueTypeHdn.val('error');
			EPK.Shoho.Payment.$creditValueDateHdn.val('error');
		}
	});
}

EPK.Shoho.Action = function() {}

/* Action.Index */
EPK.Shoho.Action.Index = function() {
	this.$confirmAnchor = $('#confirm-anchor');
	this.$confirmAlertPopupBtn = $('.res-send-button .reserve-popup-send input');

	// クーポンフィールドの非同期取得
	$.ajax({
		url: '/shoho/getPointField',
		type: 'POST',
		data: {
			'shop_id': EPK.Shoho.ARG.pharmacyId,
			'selected_coupon': EPK.Shoho.selectedCoupon,
			'error_coupon_list': EPK.Shoho.errorCouponList
		},
		dataType: 'HTML'
	})
	.done(function(data) {
		$('.use-ptcpn').append(data);
		if ($('.use-ptcpn').find('h2').length == 0) {
			$('.use-ptcpn').remove();
		}
	});

	// 前回の予約情報ポップアップ表示
	this.latestShohoReserve();

	// 非ログイン時のログインポップアップ表示
	this.selectLoginPopup();

	// 残必須項目数表示
	EPK.Shoho.FloatRequired.init();
}

EPK.Shoho.Action.Index.prototype.initEvent = function() {
	var _this = this;

	// 	Alert Popup
	this.$confirmAlertPopupBtn.on('click', function() {
		if ($(this).hasClass('is-popup')) {
			_this.$confirmAnchor.trigger('click');
		}
	});

	// 受取希望時間ポップアップ
	EPK.desiredReceptionTimePopup.init();
}

EPK.Shoho.Action.Index.prototype.latestShohoReserve = function() {
	var $latestShohoReserve = $('#modal-latest-shoho-reserve');

	if ($latestShohoReserve.length == 0) {
		return;
	}

	$.magnificPopup.open({
		items: {src: '#modal-latest-shoho-reserve'},
		type: 'inline',
		modal: true,
	}, 0);

	$latestShohoReserve.find('.use-btn').find('a').on('click', function() {
		$('[name=category2]').val($('#c_v_2').data('value'));

		if ($('#c_v_4').data('value') > 0) {
			$('[name=category4]').val($('#c_v_4').data('value'));
		}

		if ($('#c_v_5').data('value') > 0) {
			$('[name=category5]').val($('#c_v_5').data('value'));
		}

		if ($('#c_receive_message').data('value')) {
			$('#res-freetext').val($('#c_receive_message').data('value'));
		}

		EPK.Shoho.FloatRequired.initView();
		$.magnificPopup.close();
	});
};

EPK.Shoho.Action.Index.prototype.selectLoginPopup = function() {
	var $selectLogin = $('#modal-select-login');

	if ($selectLogin.length == 0) {
		return;
	}

	$.magnificPopup.open({
		items: {src: '#modal-select-login'},
		type: 'inline',
		modal: true,
	}, 0);
};

EPK.Shoho.Coupon = function(apiErrorFlag) {
	this.apiErrorFlag = apiErrorFlag;

	this.hasPoint = parseInt($('.use-pt').find('b').text().replace(',',''));
	this.availablePoint = this.hasPoint;
	this.$usePoint = $('.use-pt').find('b');
	this.$usedPoint = $('.used-pt').find('b');
	this.$pointShortageModalAvailablePoint = $('#modal-available-pt dd b');
	this.$pointShortageModalNowPoint = $('#modal-now-pt dd b');
	this.$pointShortageModalCalcPoint = $('#modal-calc-pt dd b');
}

EPK.Shoho.Coupon.prototype.init = function() {
	this.initEvent();
	this.initView();

	// クーポンが選択されている場合はポップアップ内にメッセージ追加
	if ($('.coupon-slide:checked').length > 0) {
		this.addPopupClass();
	}
}

EPK.Shoho.Coupon.prototype.initEvent = function() {
	var _this = this;
	// クーポン詳細ポップアップ
	$('.modal-coupon-btn').on('click', function() {
		var target = $(this).data('target');
		_this.openPopup(target);
	});

	// クーポン選択
	$('.coupon-slide').on('change', function() {
		// #22286 add
		_this.availablePoint = 0;

		var point = parseInt($(this).data('point'));
		var remainingPoint = _this.availablePoint - point;

		if ($(this).prop('checked')) {
			if (remainingPoint >= 0) {
				// 無料クーポンは何もしない
				if (remainingPoint > 0) {
					// 利用可能ポイントから減算
					_this.availablePoint -= point;
					_this.$usedPoint.text(_this.numSeparate(_this.availablePoint));
					_this.$pointShortageModalNowPoint.text(_this.numSeparate(_this.hasPoint - _this.availablePoint));
				}
			} else {
				$(this).prop('checked', false);
				if (_this.apiErrorFlag) {
					_this.openPopup('#modal-coupon-point-acquisition-error');
				} else {
					_this.$pointShortageModalCalcPoint.text('-' + _this.numSeparate(point - _this.availablePoint));
					_this.openPopup('#modal-coupon-point-shortage');
				}
			}
		} else {
			// 利用可能ポイントに加算
			_this.availablePoint += point;
			_this.$usedPoint.text(_this.numSeparate(_this.availablePoint));
			_this.$pointShortageModalNowPoint.text(_this.numSeparate(_this.hasPoint - _this.availablePoint));
		}

		// クーポンが選択されている場合はポップアップ内にメッセージ追加
		if ($('.coupon-slide:checked').length > 0) {
			_this.addPopupClass();
		} else {
			_this.removePopupClass();
		}
	});
}

EPK.Shoho.Coupon.prototype.initView = function() {
	var _this = this;
	var errorPoint = 'ー';

	if (!this.apiErrorFlag) {
		// 選択済みのクーポンのポイントを減算
		$.each($('.coupon-slide'), function(i, e) {
			if ($(this).prop('checked')) {
				_this.availablePoint -= parseInt($(this).data('point'));
			}
		});

		// EPARKポイント初期表示
		this.$usedPoint.text(this.numSeparate(this.availablePoint));
		this.$pointShortageModalNowPoint.text(0);

		if (errorPoint == this.$usePoint.text()) {
			this.$usePoint.text(this.numSeparate(this.availablePoint));
			this.$pointShortageModalAvailablePoint.text(this.numSeparate(this.availablePoint));
		}
	} else {
		this.$usePoint.text(errorPoint);
		this.$usedPoint.text(errorPoint);
	}
}

EPK.Shoho.Coupon.prototype.numSeparate = function(num) {
	num = String(num);

	var strMinus = '';
	if (num.indexOf('-') > -1) {
		strMinus = '-';
	}

	num = num.replace(/-/g, '');
	var len = num.length;

	if (len > 3) {
		// 前半を引数に再帰呼び出し + 後半3桁
		return strMinus + this.numSeparate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
	} else {
		return strMinus + num;
	}
}

EPK.Shoho.Coupon.prototype.openPopup = function(src) {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: src},
		type: 'inline',
		modal: true,
	}, 0);
}

EPK.Shoho.Coupon.prototype.addPopupClass = function() {
	$('#confirm-btn').addClass('is-popup');
}

EPK.Shoho.Coupon.prototype.removePopupClass = function() {
	$('#confirm-btn').removeClass('is-popup');
}

EPK.Shoho.FloatRequired = EPK.Shoho.FloatRequired || {};

/**
 * 初回残必須項目数表示
 */
EPK.Shoho.FloatRequired.initView = function() {
	$.each(EPK.Shoho.FloatRequired.categoryIdList, function(index, el) {
		EPK.Shoho.FloatRequired.status(el)
	});

	// ゲスト情報入力フォーム
	if (!EPK.common.isLogin) {
		// メールアドレス
		var mailStatus = EPK.Shoho.Validate.email($('#mail').val());
		EPK.Shoho.FloatRequired.categoryIdValidList['mail'] = mailStatus['valid'];

		// 呼び出し名
		var nameStatus = EPK.Shoho.Validate.handleName($('#name').val());
		EPK.Shoho.FloatRequired.categoryIdValidList['name'] = nameStatus['valid'];
	}

	EPK.Shoho.FloatRequired.view();
};

/**
 * 残必須項目数表示
 */
EPK.Shoho.FloatRequired.view = function() {
	var validCount = EPK.Shoho.FloatRequired.validCount;
	$.each(EPK.Shoho.FloatRequired.categoryIdList, function(index, el) {
		if (EPK.Shoho.FloatRequired.categoryIdValidList['c'+el]) {
			validCount--;
		}
	});

	// ゲスト情報入力フォーム
	if (!EPK.common.isLogin) {
		// メールアドレス
		if (EPK.Shoho.FloatRequired.categoryIdValidList['mail']) {
			validCount--;
		}

		// 呼び出し名
		if (EPK.Shoho.FloatRequired.categoryIdValidList['name']) {
			validCount--;
		}
	}

	$('#float-validate-num').text(EPK.Shoho.toFullWidth(validCount));
};

/**
 * エラーメッセージ表示/非表示
 */
EPK.Shoho.FloatRequired.viewError = function(error, categoryId, message) {
	categoryId = categoryId + '';
	switch (categoryId) {
		case '1':
		case '2':
			var element = $('[name=category' + categoryId + ']');
			element.parent().parent().find('.error-message').remove();
			if (error) {
				element.parent().parent().append($('<div>', {class: 'error-message'}).text(message));
				element.addClass('form-error');
			} else {
				element.removeClass('form-error');
			}
			break;

		case '4':
		case '5':
			var element = $('[name=category' + categoryId + ']');
			element.parent().parent().find('.error-message').remove();
			if (error) {
				element.parent().after($('<div>', {class: 'error-message'}).text(message));
				element.addClass('form-error');
			} else {
				element.removeClass('form-error');
			}
			break;

		case 'mail':
		case 'name':
			var element = $('#' + categoryId);
			element.parent().find('.error-message').remove();
			if (error) {
				element.parent().append($('<div>', {class: 'error-message'}).text(message));
				element.addClass('form-error');
			} else {
				element.removeClass('form-error');
			}
			break;

		default:
			break;
	}
};

/**
 * 初期化処理
 */
EPK.Shoho.FloatRequired.init = function() {
	var _this = this;
	EPK.Shoho.FloatRequired.validCount = EPK.common.isLogin ? 5 : 6;
	EPK.Shoho.FloatRequired.categoryIdList = [1,2,4,5];
	EPK.Shoho.FloatRequired.categoryIdValidList = [];
	EPK.Shoho.FloatRequired.handlingElementList = {
		2: '#category2',
		4: '[name=category4]',
		5: '[name=category5]',
	};
	if (EPK.common.isLogin) {
		EPK.Shoho.FloatRequired.categoryIdList.push(6);
	}

	EPK.Shoho.FloatRequired.initView();

	$.each(EPK.Shoho.FloatRequired.handlingElementList, function(categoryId, selector) {
		// 受取希望時間以外はフォーカスアウトのときにカウンターを増減させる
		$(selector).focusout(function(event) {
			var result = EPK.Shoho.FloatRequired.status(categoryId);
			EPK.Shoho.FloatRequired.view();
			EPK.Shoho.FloatRequired.viewError(!result['valid'], categoryId, result['message']);
		});
	});

	// ゲスト情報入力
	// メールアドレス
	$('#mail').focusout(function(event) {
		var result = EPK.Shoho.Validate.email($(this).val());
		EPK.Shoho.FloatRequired.categoryIdValidList['mail'] = result['valid'];
		EPK.Shoho.FloatRequired.view();
		EPK.Shoho.FloatRequired.viewError(!result['valid'], 'mail', result['message']);
	});
	// 呼び出し名
	$('#name').focusout(function(event) {
		var result = EPK.Shoho.Validate.handleName($(this).val());
		EPK.Shoho.FloatRequired.categoryIdValidList['name'] = result['valid'];
		EPK.Shoho.FloatRequired.view();
		EPK.Shoho.FloatRequired.viewError(!result['valid'], 'name', result['message']);
	});

	var FileUploader = new EPK.Shoho.FileUploader(EPK.Shoho.ARG.pharmacyId);
	$('input[type="radio"][name="pay"]').on('click',function() {
		var result = EPK.Shoho.FloatRequired.status(6);
		EPK.Shoho.FloatRequired.categoryIdValidList['pay'] = result['valid'];
		EPK.Shoho.FloatRequired.view();
		FileUploader.changeBtnProp(false)
	});
};

/**
 * 必須項目の入力選択状況
 */
EPK.Shoho.FloatRequired.status = function(categoryId) {
	categoryId = categoryId + '';
	var status = false;
	var el = $('[name=category'+categoryId+']');
	var result;

	switch (categoryId) {
		case '1':	// 受取希望時間
			result = EPK.Shoho.Validate.shopOpenTime(el.val());
			break;

		case '2':	// 電話番号
			result = EPK.Shoho.Validate.tel(el.val());
			break;

		case '4':	// ジェネリック
		case '5':	// お薬手帳
			result = EPK.Shoho.Validate.selectTag(el.val());
			break;

		case '6': //お支払方法
			result = EPK.Shoho.Validate.payment(el);
		default:
			break;
	}

	EPK.Shoho.FloatRequired.categoryIdValidList['c'+categoryId] = result['valid'];

	return result;
}

/**
 * 半角英数 ⇒ 全角英数 に変換
 */
EPK.Shoho.toFullWidth = function(val) {
    return (val + '').replace(/[A-Za-z0-9!-~]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0)+0xFEE0);
    });
}

EPK.Shoho.Validate = EPK.Shoho.Validate || {};

/**
 * 電話番号のバリデート
 */
EPK.Shoho.Validate.tel = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	val = val.replace(/[-ー－―‐]/g, '');

	// 文字数チェック
	if (val.length <= 0) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	// 先頭3文字で携帯電話か判定
	if (val.match(/^0(5|7|8|9)0/)) {
		if (!val.match(/^0[5,6,7,8,9]0[0-9]{8}$/ui)) {
			result['message'] = '携帯電話番号の桁数が正しくありません。';
		} else {
			result['valid'] = true;
		}
	} else {
		if (!val.match(/^[0-9]{10,11}$/ui)) {
			result['message'] = '電話番号の形式が正しくありません。';
		} else {
			result['valid'] = true;
		}
	}

	return result;
};

/**
 * 受取希望時間のバリデート
 */
EPK.Shoho.Validate.shopOpenTime = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	if (val.match(/^今すぐ（送信後15分目安）$/)) {
		// 今すぐ
		result['valid'] = true;
	} else if (val.match(/^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[1,2][0-9]|3[0,1]) ([0,1][0-9]|2[0-3]):(0[0-9]|[1-5][0-9]):(0[0-9]|[1-5][0-9])$/)) {
		// yyyy-mm-dd hh:ii:ss
		result['valid'] = true;
	} else {
		result['message'] = 'お薬お受け取り希望日時の形式が正しくありません。';
	}

	return result;
};

/**
 * プルダウンのバリデート
 */
EPK.Shoho.Validate.selectTag = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '選択必須事項です。';
		return result;
	}

	// 文字数チェック
	if (val.length <= 0) {
		result['message'] = '選択必須事項です。';
		return result;
	}

	result['valid'] = true;

	return result;
};

/**
 * メールアドレスのバリデート
 */
EPK.Shoho.Validate.email = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	// 文字数チェック
	if (val.length > 255) {
		result['message'] = '255文字以内で入力してください。';
		return result;
	}

	// 入力形式チェック
	if (!val.match(/^.*@.*$/)
		|| !val.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-]+\.)+([a-zA-Z0-9_-]+)+$/)
	) {
		result['message'] = 'メールアドレスの形式が不正です。';
		return result;
	}

	result['valid'] = true;

	return result;
};

/**
 * 呼び出し名のバリデート
 */
EPK.Shoho.Validate.handleName = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	// 文字数チェック
	if (val.length < 2 || 14 < val.length) {
		result['message'] = '2文字以上、14文字以下で入力してください。';
		return result;
	}

	// 入力形式チェック
	if (!val.match(/^[ぁ-んー]+$/)) {
		result['message'] = 'ひらがなで入力してください。';
		return result;
	}

	result['valid'] = true;

	return result;
};

/**
 * お支払方法のバリデート
 */
EPK.Shoho.Validate.payment = function(val) {
	var result = [];
	result['message'] = '';
	if (EPK.common.isLogin) {
		result['valid'] = true;
	}
	result['valid'] = false;

	// チェック確認
	var payMethods = val.find('input[type="radio"][name="pay"]');
	var count = 0;
	if (payMethods.length > 0) {
		$.each(payMethods,function (i,el) {
			if ($(el).prop('checked')) {
				count++;
			}
		})
		if (count <= 0) {
			result['message'] = '選択必須事項です。';
			return result;
		}
	}

	result['valid'] = true;

	return result;
};

EPK.desiredReceptionTimePopup = EPK.desiredReceptionTimePopup || {};
EPK.desiredReceptionTimePopup.init = function() {
	EPK.desiredReceptionTimePopup.dayOk = 'select-day-ok';
	EPK.desiredReceptionTimePopup.dayNg = 'select-day-ng';
	EPK.desiredReceptionTimePopup.submitFlag = false;
	EPK.desiredReceptionTimePopup.urlShohoIndex = '';
	EPK.desiredReceptionTimePopup.$daySelect = $('#select-day');
	EPK.desiredReceptionTimePopup.$daySelectLabel = $('.select-box-day label span');
	EPK.desiredReceptionTimePopup.$Rev = $('.rev');
	EPK.desiredReceptionTimePopup.$Fwd = $('.fwd');
	EPK.desiredReceptionTimePopup.$SelectTime = $('.select-time');
	EPK.desiredReceptionTimePopup.$SelectTimeHidden = $('#select-time-hidden');
	EPK.desiredReceptionTimePopup.$SelectTimeName = $('[name=select-time]');
	EPK.desiredReceptionTimePopup.$SelectTimeSubtext = $('.select-time-subtext');
	EPK.desiredReceptionTimePopup.$SelectTimeSubtextAsSoonAs = $('.select-time-subtext-as-soon-as');
	EPK.desiredReceptionTimePopup.$SelectTimeList = $('.select-time-list');
	EPK.desiredReceptionTimePopup.$SelectNoReserveBox = $('.select-no-reserve-box');
	EPK.desiredReceptionTimePopup.$SubmitBtn = $('.calendar_submit_btn');
	EPK.desiredReceptionTimePopup.$JsErrorText = $('#js-error-text');
	EPK.desiredReceptionTimePopup.$ModalSelectDaytimeBtn = $('.modal-select-daytime-btn');
	EPK.desiredReceptionTimePopup.$inputReceiveTime = $('.modal-select-daytime-btn');
	EPK.desiredReceptionTimePopup.$inputReceiveTimeHidden = $('#receive-time-hidden');

	EPK.Shoho.openTimes = EPK.Shoho.openTimes || {};
	EPK.Shoho.openTimes['lastTimes'] = [];

	EPK.Shoho.openTimes['days'].forEach(function(day, index){
		var arrKey = EPK.Shoho.openTimes['day_strings'][index].replace(/-/g, '');
		var opentimes = EPK.Shoho.openTimes['opentimes'][index];
		EPK.Shoho.openTimes['lastTimes'][arrKey] = [];
		EPK.Shoho.openTimes['lastTimes'][arrKey]['hour'] = null;
		EPK.Shoho.openTimes['lastTimes'][arrKey]['minute'] = null;

		if (opentimes['open24_flag']) {
			EPK.Shoho.openTimes['lastTimes'][arrKey]['hour'] = 24;
			EPK.Shoho.openTimes['lastTimes'][arrKey]['minute'] = 0;
		} else {
			var openTimeIndexes = [1,2,3];
			openTimeIndexes.forEach(function(i, el) {
				if (opentimes['open_time' + i] && opentimes['close_time' + i]) {
					var open = new Date(opentimes['open_time' + i].split('+')[0] + '+09:00');
					var close = new Date(opentimes['close_time' + i].split('+')[0] + '+09:00');

					var formated = EPK.Shoho.Popup.formatDate(close, 'hh:mm').split(':');
					if (formated[0] != formated[1]) {
						EPK.Shoho.openTimes['lastTimes'][arrKey]['hour'] = parseInt(formated[0]);
						EPK.Shoho.openTimes['lastTimes'][arrKey]['minute'] = parseInt(formated[1]);
					}
				}
			});
		}
	});

	EPK.desiredReceptionTimePopup.$ModalSelectDaytimeBtn.on('click', function() {
		function getSelectVal(today) {
			var selectVal = '';
			EPK.desiredReceptionTimePopup.SelectInitialize();
			$.each(EPK.desiredReceptionTimePopup.$daySelect.find('option'), function(i, e) {
					var value = $(e).val();
					if (value.match(/1-/)) {
							selectVal = value;
							return false;
					}
			});
			if (selectVal.length > 0) {
					return selectVal;
			}
			return '0-' + today;
		}

		// 指定した日付が選択できる状態かチェック
		function checkSelectedDate(selectedDate) {
			var checked = false;

			$.each(EPK.desiredReceptionTimePopup.$daySelect.find('option'), function(i, e) {
					var value = $(e).val();
					var regexp = new RegExp('1-' + selectedDate);
					if (value.match(regexp)) {
							checked = true;
							return false;
					}
			});

			return checked;
		}

		// スライドの存在チェック
		function checkSelectedSlide(selectedSlide) {
			return $('#t' + selectedSlide).length > 0;
		}

		/*
		 * 指定したスライドが左から何番目かを取得
		 * ※番号は0始まり
		 */
		function getSelectedSlideNum(selectedSlide) {
			var targetId = 't' + selectedSlide;
			var $selectedSlide = $('#' + targetId);
			var index = 0;
			$.each($selectedSlide.closest('ul').find('input[type=radio]'), function(i, el) {
				if ($(el).prop('id') == targetId) {
					index = i;
					return false;
				}
			});

			return index;
		}

		var day = $(this).data('day');
		var slide = $(this).data('slide');

		EPK.desiredReceptionTimePopup.reserveSchedulePopup(slide);
		var selectVal = getSelectVal(day);

		// 受取希望時間が選択済みの場合は、ポップアップ内の日付/時間を選択済みの状態にする
		var selectedVal = EPK.desiredReceptionTimePopup.$inputReceiveTimeHidden.val();
		if (selectedVal) {
			var selectedDate, selectedSlide;
			// 「今すぐ」のスライドを選択しているかの判定
			if (selectedVal.match(/今すぐ/)) {
				selectedDate = EPK.Shoho.Popup.formatDate(new Date(), 'YYYYMMDD', true);
				selectedSlide = 'now';
			} else {
				// iOS対応で日付を「-」から「/」へ
				selectedDate = EPK.Shoho.Popup.formatDate(new Date(selectedVal.replace(/-/g, '/')), 'YYYYMMDD', true);
				selectedSlide = EPK.Shoho.Popup.formatDate(new Date(selectedVal.replace(/-/g, '/')), 'YYYYMMDDhhmm', true);
			}

			if (checkSelectedDate(selectedDate) && checkSelectedSlide(selectedSlide)) {
				// 指定日付のスライダーを表示
				EPK.desiredReceptionTimePopup.SelectOkDay(selectedDate);
				// 日付のプルダウンを指定日付に選択した状態にする
				EPK.desiredReceptionTimePopup.$daySelect.val('1-' + selectedDate);
				// スライドを選択済み状態にする
				$('#t' + selectedSlide).prop('checked', true);
				$('#t' + selectedSlide).click();
				var slideNum = getSelectedSlideNum(selectedSlide);
				// 初期スライド(0番目)以外が選択されている場合は、スライダーの初期位置を指定
				if (slideNum) {
					EPK.desiredReceptionTimePopup.reserveSchedulePopupSwiperInitialize(slideNum);
				}
				// 選択したスライドの文言を表示
				EPK.desiredReceptionTimePopup.$SelectTime.text('○ ' + $('#t' + selectedSlide).val());
				EPK.desiredReceptionTimePopup.$SelectTime.append(EPK.desiredReceptionTimePopup.getTimeAfterText());
				// 決定ボタン周りの制御
				EPK.desiredReceptionTimePopup.submitFlag = true;
				EPK.desiredReceptionTimePopup.$SubmitBtn.removeClass('disabled');
			}
			// 選択済み日時が選択不可だった場合は、選択できる時間のある当日日付に近い日にちのスライダーで未選択状態
			else {
				EPK.desiredReceptionTimePopup.SelectOkDay(selectVal.replace(/[0,1]-/, ''));
				EPK.desiredReceptionTimePopup.$daySelect.val(selectVal);
				EPK.desiredReceptionTimePopup.checkLabelOkOrNg(selectVal);
			}
		}
		// 受取希望時間未選択
		else {
			EPK.desiredReceptionTimePopup.SelectOkDay(selectVal.replace(/[0,1]-/, ''));
			EPK.desiredReceptionTimePopup.$daySelect.val(selectVal);
			EPK.desiredReceptionTimePopup.checkLabelOkOrNg(selectVal);
		}
	});

	EPK.desiredReceptionTimePopup.checkLabelOkOrNg = function(selectVal) {
		var selectValSpl = selectVal.split('-');
		var selected = selectValSpl[0];
		var day = selectValSpl[1];
		var checkReserve = EPK.desiredReceptionTimePopup.$daySelect.hasClass(EPK.desiredReceptionTimePopup.dayOk);
		if (selected == 0) {
			EPK.desiredReceptionTimePopup.SelectNgDay();
			if (!checkReserve) {
				EPK.desiredReceptionTimePopup.$daySelectLabel.addClass(EPK.desiredReceptionTimePopup.dayNg);
				EPK.desiredReceptionTimePopup.$daySelectLabel.removeClass(EPK.desiredReceptionTimePopup.dayOk);
				EPK.desiredReceptionTimePopup.$daySelectLabel.text('×');
			}
		} else {
			EPK.desiredReceptionTimePopup.SelectOkDay(day);
			if (!checkReserve) {
				EPK.desiredReceptionTimePopup.$daySelectLabel.addClass(EPK.desiredReceptionTimePopup.dayOk);
				EPK.desiredReceptionTimePopup.$daySelectLabel.removeClass(EPK.desiredReceptionTimePopup.dayNg);
				EPK.desiredReceptionTimePopup.$daySelectLabel.text('○');
			}
		}
	};

	EPK.desiredReceptionTimePopup.$daySelect.on('change', function() {
		var selectVal = $(this).val();
		EPK.desiredReceptionTimePopup.checkLabelOkOrNg(selectVal);
	});

	EPK.desiredReceptionTimePopup.$SelectTimeName.on('click', function() {
		var id = $(this).attr('id').replace('t', '');
		EPK.desiredReceptionTimePopup.$SelectTimeHidden.val(id);
		EPK.desiredReceptionTimePopup.$SelectTime.text('○ ' + $(this).val());
		EPK.desiredReceptionTimePopup.$SelectTime.append(EPK.desiredReceptionTimePopup.getTimeAfterText());

		EPK.desiredReceptionTimePopup.submitFlag = true;
		EPK.desiredReceptionTimePopup.$SubmitBtn.removeClass('disabled');
	});

	EPK.desiredReceptionTimePopup.$SubmitBtn.on('click', function() {
		if (EPK.desiredReceptionTimePopup.submitFlag) {
			var selectedTime = EPK.desiredReceptionTimePopup.$SelectTimeHidden.val();
			if (selectedTime != 'now') {
				var dateObj = new Date(
					selectedTime.slice(0, 4),
					('0' + (selectedTime.slice(4, 6)*1 - 1)).slice(-2),
					selectedTime.slice(6, 8),
					selectedTime.slice(8, 10),
					selectedTime.slice(10, 12)
				);
				var receiveTimeAfterText = EPK.desiredReceptionTimePopup.checkViewTimeAfterText() ? ' 以降' : '';
				EPK.desiredReceptionTimePopup.$inputReceiveTime.val(EPK.Shoho.Popup.formatDate(dateObj, 'MM/DD（week） hh：mm', false) + receiveTimeAfterText);
				EPK.desiredReceptionTimePopup.$inputReceiveTimeHidden.val(EPK.Shoho.Popup.formatDate(dateObj, 'YYYY-MM-DD hh:mm:ss', true));
			} else {
				var asSoonAsText = '今すぐ（送信後15分目安）';
				EPK.desiredReceptionTimePopup.$inputReceiveTime.val(asSoonAsText);
				EPK.desiredReceptionTimePopup.$inputReceiveTimeHidden.val(asSoonAsText);
			}

			// 必須項目残り数
			var result = EPK.Shoho.FloatRequired.status(1);
			EPK.Shoho.FloatRequired.view();
			EPK.Shoho.FloatRequired.viewError(!result['valid'], 1, result['message']);

			$.magnificPopup.close();

			// スライダーのスライド選択状態を解除
			$('[name=select-time]:checked').prop('checked', false);
		} else {
			EPK.desiredReceptionTimePopup.$JsErrorText.text('時刻を選択してください。');
		}
	});
};

EPK.desiredReceptionTimePopup.reserveSchedulePopupSwiperInitialize = function(slide) {
	$.each(EPK.desiredReceptionTimePopup.days, function(index, element) {
		var swiper = $('#reserve-schedule-day' + element).swiper({
			centeredSlides: true,
			initialSlide: slide,
			slidesPerView: 'auto',
			loop: false,
		});
	});
};

EPK.desiredReceptionTimePopup.reserveSchedulePopup  = function(slide) {
	$.magnificPopup.open({
		items: {
			src: '#modal-select-daytime',
		},
		type: 'inline',
		modal: true,
		callbacks: {
			open: function() {
				EPK.desiredReceptionTimePopup.reserveSchedulePopupSwiperInitialize(slide);
			}
		}
	});
};

EPK.desiredReceptionTimePopup.SelectInitialize = function() {
	EPK.desiredReceptionTimePopup.$Rev.hide();
	EPK.desiredReceptionTimePopup.$Fwd.hide();
	EPK.desiredReceptionTimePopup.$SelectTimeList.hide();
	EPK.desiredReceptionTimePopup.$SelectTimeSubtext.hide();
	EPK.desiredReceptionTimePopup.$SelectTimeSubtextAsSoonAs.hide();
	EPK.desiredReceptionTimePopup.$SelectNoReserveBox.hide();
	EPK.desiredReceptionTimePopup.$SubmitBtn.hide();
	var initSelectTime = '<span class="init-msg">下記より時間を<br>選択して下さい</span>';
	EPK.desiredReceptionTimePopup.$SelectTime.html(initSelectTime);
	EPK.desiredReceptionTimePopup.$JsErrorText.text('');
	EPK.desiredReceptionTimePopup.$SelectTimeHidden.val();
	EPK.desiredReceptionTimePopup.submitFlag = false;
	EPK.desiredReceptionTimePopup.$SubmitBtn.addClass('disabled');
	EPK.desiredReceptionTimePopup.$SelectTimeName.prop('checked', false);

	EPK.desiredReceptionTimePopup.$SelectTimeList.each(function(index) {
		var day = $(this).attr('id').replace('day', '');
		if (!$(this).children()[0]) {
			$(EPK.desiredReceptionTimePopup.$daySelect.children('option')[index]).val('0-' + day);
		}
	});
};

EPK.desiredReceptionTimePopup.SelectOkDay = function(day) {
	var selectTodayTimeList = $('#day' + day);

	EPK.desiredReceptionTimePopup.SelectInitialize();
	EPK.desiredReceptionTimePopup.$Rev.show();
	EPK.desiredReceptionTimePopup.$Fwd.show();
	selectTodayTimeList.show();
	if(selectTodayTimeList.has('li > #tnow').length) {
		EPK.desiredReceptionTimePopup.$SelectTimeSubtextAsSoonAs.show();
	}
	EPK.desiredReceptionTimePopup.$SubmitBtn.show();
	EPK.desiredReceptionTimePopup.$SelectTimeSubtext.show();
};

EPK.desiredReceptionTimePopup.SelectNgDay = function() {
	EPK.desiredReceptionTimePopup.SelectInitialize();
	EPK.desiredReceptionTimePopup.$SubmitBtn.show();
	EPK.desiredReceptionTimePopup.$SelectNoReserveBox.show();
};

/**
 * true:「以降」を出す false: 「以降」を出さない
 * @return bool
 */
EPK.desiredReceptionTimePopup.checkViewTimeAfterText = function() {
	var selectedTime = EPK.desiredReceptionTimePopup.$SelectTimeHidden.val();

	if (selectedTime == 'now' || selectedTime == '') {
		return false;
	}

	var hour = parseInt(selectedTime.slice(8, 10));
	var minute = parseInt(selectedTime.slice(10, 12));
	var lastTime = EPK.Shoho.openTimes['lastTimes'][selectedTime.slice(0, 8)];

	return lastTime['hour'] != hour || lastTime['minute'] != minute;
};

EPK.desiredReceptionTimePopup.getTimeAfterText = function() {
	var $afterText = '';

	if (EPK.desiredReceptionTimePopup.checkViewTimeAfterText()) {
		$afterText = $('<span>', {id: 'select-popup3_minute_after_text'}).html('&nbsp;以降');
	}

	return $afterText;
}

/**
 * #13510
 * お支払方法チェック確認
 */
EPK.Shoho.paymentCheck = function() {

	// チェック確認
	var payMethods = $('#credit').find('input[type="radio"][name="pay"]');
	var count = 0;
	if (payMethods.length > 0) {
		$.each(payMethods,function (i,el) {
			if ($(el).prop('checked')) {
				count++;
			}
		})
		if (count <= 0) {
			EPK.Shoho.FloatRequired.categoryIdValidList['pay'] = false
		} else if (count >= 1) {
			//var result = EPK.Shoho.Validate.payment($('[name="category6"]'))
			var result = EPK.Shoho.FloatRequired.status(6);
			EPK.Shoho.FloatRequired.view();
			EPK.Shoho.FloatRequired.categoryIdValidList['pay'] = result['valid'];
		}
	}
}

EPK.Shoho.MedicineReport = EPK.Shoho.MedicineReport || {};
EPK.Shoho.MedicineReport = function(mUserDetailList, medicineReportShopId, medicineReportReserveBundleId) {
	var _this = this;

	this.mUserDetailList = mUserDetailList;
	this.medicineReportShopId = medicineReportShopId;
	this.medicineReportReserveBundleId = medicineReportReserveBundleId;

	this.deleteTechoLoadingElement();
	this.initEvent();

	// ユーザ情報未入力、未選択状態で、ユーザ選択のプルダウンがあるとき、
	// プルダウンで選択されているユーザ情報を初期入力値としてセットする
	if ($('[name=last_name]').val() == ''
		&& $('[name=first_name]').val() == ''
		&& $('[name=last_name_kana]').val() == ''
		&& $('[name=first_name_kana]').val() == ''
		&& $('#birthdayYear').val() == '1980'
		&& $('#birthdayMonth').val() == '01'
		&& $('#birthdayDay').val() == '01'
		&& $('[name=gender]:checked').val() == undefined
	) {
		var userId = $('#m_user_select_box').val();
		$.each(this.mUserDetailList, function(id, userDetail) {
			if (id == userId) {
				_this.setMUserDetailToForm(_this.mUserDetailList[userId]);
				return false;
			}
		});
	}
}

EPK.Shoho.MedicineReport.prototype.initEvent = function() {
	var _this = this;

	$('#techo_tips').on('click', function() {
		_this.openModal('#techo_tips_elem');
	})

	// フォーム入力
	$('#btn_medicinereportindex_submit').on('click', function(event) {
		event.preventDefault();
		_this.createTechoLoadingElement();
		var form = $(this).closest('form');
		$('.techo-loading img').load(function() {
			form.submit();
		});
	});
	// フォーム確認
	$('#btn_medicinereportconfirm_submit').on('click', function() {
		_this.doMedicineReport();
	});
	// フォーム確認戻り
	$('#btn_medicinereportconfirm_return_anchor').on('click', function(event) {
		event.preventDefault();
		_this.createTechoLoadingElement();
		var href = $(this).attr('href');
		$('.techo-loading img').load(function() {
			location.href = href;
		});
	});

	// お薬手帳ユーザ選択時、フォームの初期値としてユーザ情報をセット
	$('#m_user_select_box').on('change', function() {
		_this.createTechoLoadingElement();

		var userId = $(this).val();
		$.each(_this.mUserDetailList, function(id, userDetail) {
			if (id == userId) {
				_this.setMUserDetailToForm(_this.mUserDetailList[userId]);
				return false;
			}
		});

		_this.deleteTechoLoadingElement();
	});
}

EPK.Shoho.MedicineReport.prototype.createTechoLoadingElement = function() {
	this.deleteTechoLoadingElement();
	var techoLoadingElem = $('<div>', {class: 'techo-loading'}).append($('<img>', {src: '/mobile/img/reserve/loading.svg'}));
	$('body').prepend(techoLoadingElem);
	$('body').css({'position': 'fixed'});
}

EPK.Shoho.MedicineReport.prototype.deleteTechoLoadingElement = function() {
	$('.techo-loading').remove();
	$('body').css({'position': ''});
}

EPK.Shoho.MedicineReport.prototype.setMUserDetailToForm = function(mUserDtail) {
	var schemas = [
		{'key': 'last_name', 'type': 'text'},
		{'key': 'first_name', 'type': 'text'},
		{'key': 'last_name_kana', 'type': 'text'},
		{'key': 'first_name_kana', 'type': 'text'},
		{'key': 'birthday', 'type': 'date'},
		{'key': 'gender', 'type': 'radio'},
	];

	$.each(schemas, function(i, schema) {
		if (!mUserDtail[schema.key]) {
			return true;
		}

		if (schema.key === 'birthday') {
			// 初期化
			$('#birthdayYear').val('1980');
			$('#birthdayMonth').val('01');
			$('#birthdayDay').val('01');

			var replaceBirthday = mUserDtail[schema.key].replace(/-/g, '');
			var year = replaceBirthday.slice(0,4);
			var month = replaceBirthday.slice(4,6);
			var day = replaceBirthday.slice(-2);
			$('#birthdayYear').val(year);
			$('#birthdayMonth').val(month);
			$('#birthdayDay').val(day);
		} else if (schema.type === 'radio') {
			// 初期化
			$('[name='+schema.key+']:checked').prop('checked', false);
			$.each($('[name='+schema.key+']'), function(i,e) {
				if ($(e).val() == mUserDtail[schema.key]) {
					$(e).prop('checked', true);
				}
			});
		} else {
			// 初期化
			$('[name='+schema.key+']').val('');
			$('[name='+schema.key+']').val(mUserDtail[schema.key]);
		}
	});
}


EPK.Shoho.MedicineReport.prototype.doMedicineReport = function() {
	var _this = this;

	this.createTechoLoadingElement();

	$.ajax({
		type: 'POST',
		url: '/api/shoho/medicine_report',
		cache: false,
		timeout: 20000,
		data: {
			'shop_id': _this.medicineReportShopId,
			'reserve_bundle_id': _this.medicineReportReserveBundleId
		}
	})
	.done(function(data) {
		if (!data.redirectUrl) {
			_this.deleteTechoLoadingElement();
			// ポップアップ表示
			_this.openModal('#techo_alert_elem');
		} else {
			location.href = data.redirectUrl;
		}
	})
	.fail(function() {
		_this.deleteTechoLoadingElement();
		// ポップアップ表示
		_this.openModal('#techo_alert_elem');
	});
}

EPK.Shoho.MedicineReport.prototype.openModal = function(src) {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: src},
		type: 'inline',
		modal: true,
	}, 0);
}

EPK.Shoho.Family = EPK.Shoho.Family || {};
EPK.Shoho.Family.addFamily = function(){
	if (EPK.common.isLogin){
		location.href = '/patient/users?back_url=shoho&person_type';	//	ログイン中は患者選択画面へ遷移
		return;
	}

	//	未ログイン中は、空きコンテナを表示
	for (var index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){	//	空きのコンテナ部分有るなら空きコンテナを表示
			$(target_id).show();
			// 一人の時に非表示にしている罫線を表示
			$('#patientselect-box-self01shoho').removeClass();
			$('#patientselect-box-self01shoho').addClass('patientselect-box');
	
			$('#added_family_number').val( Number($('#added_family_number').val()) + 1 );
			EPK.Shoho.FileUploader.prototype.changeBtnProp(true, '登録した画像は0枚です');
			break;
		}
	}
	var all_select = true;
	for (index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){	//	IDが有って、非表示のコンテナがあるときは、全て表示していない
			all_select = false;
			break;
		}
	}
	if (all_select){	//	全てのコンテナを表示している時は、「患者追加」ボタンを非表示
		$('.patientadd-btn').hide();
	}
}
EPK.Shoho.Family.imageCheck = function(){
	var all_select = true;
	for (index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){	//	IDが有って、非表示のコンテナがあるときは、全て表示していない
			all_select = false;
			break;
		}
	}
	if (all_select){
		$('.patientadd-btn').hide();
	}else{
		$('.patientadd-btn').show();
	}
}
EPK.Shoho.Family.deletePatient = function(shopId, person_type){
	$.ajax({
		type: "GET",
		url: "/shoho/image",
		cache: false,
		timeout: 20000,
		data: {
			pharmacy_id: shopId,
			person_type: person_type,
			command: 'delete_all'
		}
	}).done(function(data, textStatus, jqXHR){
		for(var index=0; index<$('#max_hospital_images').val(); index++){
			var td_id = "list-" + person_type + "-" + index;
			if ($("#" + td_id).css('display') != 'none'){
				EPK.Shoho.FileUploader.prototype.afterImageDeleted($("#" + td_id).children('a'));
			}

			var td_id = "list-" + person_type.replace('shoho', 'hospital') + "-" + index;
			if ($("#" + td_id).css('display') != 'none'){
				EPK.Shoho.FileUploader.prototype.afterImageDeleted($("#" + td_id).children('a'));
			}
		}

		var added_family_number = Number($("#added_family_number").val());
		$("#child_member_no_" + person_type).val('');	//	両方
		var target_id = 'patientselect-box-' + person_type;	//	両方

		if (added_family_number > 0){
			$("#added_family_number").val(Number(added_family_number) - 1);
			if (! EPK.common.isLogin){
				$('input[name=' + person_type + '_last_name]').val('');	//	未ログイン
				$('input[name=' + person_type + '_first_name]').val('');	//	未ログイン
			}
			$("#" + target_id).hide();
		}
		// 一人の時に非表示にしている罫線を非表示に
		if ($("#added_family_number").val() == 0){
			$('#patientselect-box-self01shoho').removeClass();
			$('#patientselect-box-self01shoho').addClass('patientselect-box is-only');
		}
	
	}).fail(function(jqXHR, textStatus, errorThrown){
	}).always(function() {

		if (! EPK.Shoho.FileUploader.prototype.countStyleDisp()){
			EPK.Shoho.FileUploader.prototype.changeBtnProp(true, '登録した画像は0枚です');
		}else{
			EPK.Shoho.FileUploader.prototype.changeBtnProp(false);
		}

		$('.patientadd-btn').show();
	});
}

$(function() {
	var pharmacyId = EPK.Shoho.ARG.pharmacyId;

	if ( location.pathname == '/shoho' ) {
		var ActionIndex = new EPK.Shoho.Action.Index();
		ActionIndex.initEvent();

		//テキストカウンター200文字
		var $textarea = $('#res-freetext');
		var $count = $('.res-count-text');
		var thisValueLength = '';
		$textarea.bind('keydown keyup keypress change paste',function() {
			thisValueLength = $textarea.val().replace(/\s+/g,'').length;
			$count.text(thisValueLength);
			if(thisValueLength > 200){
				$count.addClass('over-text');
			}else{
				$count.removeClass('over-text');
			}
		});

		// テキストカウンター
		thisValueLength = $textarea.val().replace(/\s+/g,'').length;
		$count.text(thisValueLength);

		// お客様情報のラジオボタン制御
		$('input[name="user_select"]:radio').on('change', function() {
			if ($(this).val() == 1) {
				$('.usr-free-box').hide();
				$('.res-privacy-subtext').hide();
			} else if ($(this).val() == 2) {
				$('.usr-free-box').show();
				$('.res-privacy-subtext').show();
			}
		});
// ===================
// かんたん決済
// ===================
		if ($('[name=pay]').length > 0) {
			var Payment = new EPK.Shoho.Payment();

			// #16545
			var $CardType = $('.card-type');

		// ===================
		// onload
		// ===================
			//#13510: 【予約フォーム】かんたん決済表記変更
			var howtoIcon = '<div class="howto">\n'
						  + '  <a href="javascript:void(0)" id="credit-popup" class="res-credit-q"><img class="howtoIcon"></a>\n'
						  + '  <div class="baloon">\n'
						  + '    <p>\n'
						  + '      <span>ネット決済(クレジットカード払い)とは？</span>\n'
						  + '      <span class="batu">×</span><br>ご予約時にクレジットカード決済ができるサービスです。お会計時に現金やカードを利用することがなくなりますので、手ぶらでの来局が可能になります。\n'
						  + '      <br>※VISA・Masterカードのみご利用いただけます。\n'
						  + '    </p>\n'
						  + '  </div>\n'
						  + '</div>';

			$('#pay-0').parent().addClass('res-cash');
			$('#pay-0').parent().parent().append('<p class="res-radio-box-text" style="display:block;">予約後にネット決済への変更はできませんのでご注意ください</p>');
			$('#pay-1').parent().addClass('res-credit');
//			$('#pay-1').parent().append('<a id="credit-popup" class="res-credit-q">&nbsp;</a>');
			$('#pay-1').parent().append(howtoIcon);

			// #16545
			if(EPK.Shoho.cardTypes){
				$('#pay-1').parent().append($('.card-type'));
				$CardType.css('display', '');
			}

			$('#pay-2').parent().addClass('res-credit');
//			$('#pay-2').parent().append('<a id="credit-popup" class="res-credit-q">&nbsp;</a>');
			$('#pay-2').parent().append(howtoIcon);

			if ($('input[name="pay"]:checked').val() == 1) {
				$('.res-radio-box-text').hide();
				Payment.getCardInformation();
			}

			if ($('input[name="user_select"]:checked').val() == 2) {
				$('.res-filter-black').show();
			}
		// ===================
		// onload
		// ===================

			$('input[name="pay"]:radio').on('change', function() {
				if ($(this).val() == 1) {
					// クレカ情報取得
					Payment.getCardInformation();

					// #16545
					$CardType.hide();
				} else if ($(this).val() == 2) {
					EPK.Shoho.Payment.$creditCheck.show();

					// #16545
					$CardType.show();
				} else {
					EPK.Shoho.Payment.$creditCheck.hide();

					// #16545
					$CardType.show();
				}

				// ラジオボタンのチェックでテキストを出す
				if ($('.res-pay-box input[type=radio]').prop('checked')) {
					$('.res-radio-box-text').css('display', 'block');
				} else {
					$('.res-radio-box-text').css('display', 'none');
				}
			});

			// クレカ情報取得再試行
			$('.res-card-error-btn a').on('click', function() {
				Payment.isLoad = false;
				Payment.getCardInformation();
			});

			// ポップアップ
			$('#credit-popup').on('click', function() {
				//$('#modal-credit-popup').trigger('click');
				if ($(this).hasClass('is-active')) {
					$(this).removeClass('is-active');
				} else {
					$(this).addClass('is-active');
				}
			});
			$('span.batu').on('click',function () {
				if ($('#credit-popup').hasClass('is-active')) {
					$('#credit-popup').removeClass('is-active')
				}
			})

			// お客様情報ラジオボタンでの制御
			$('input[name="user_select"]:radio').on('change', function() {
				if ($(this).val() == 1) {
					$('.res-filter-black').hide();
				} else {
					$('.res-filter-black').show();
					$('#pay-0').trigger('click');
				}
			});
		}
// ===================
// かんたん決済
// ===================
	}

	if (location.pathname == '/shoho') {
		var FileUploader = new EPK.Shoho.FileUploader(pharmacyId);

		$(document).ready(function() {
			// ページ読み込み時の disabled 判定
			EPK.Shoho.paymentCheck();
			if ($('[data-btn-flag="pay"]').length > 0 && EPK.common.isLogin && !EPK.Shoho.FloatRequired.categoryIdValidList['pay']) {
				FileUploader.changeBtnProp(true, 'お支払方法を選択してください');
			} else {
				FileUploader.changeBtnProp(false);
			}

			// 残必須項目数表示
			EPK.Shoho.FloatRequired.view();

		});
	}

	if (location.pathname == '/shoho/finish'
		|| location.pathname == '/shoho/medicineReportConfirm'
		|| location.pathname == '/shoho/medicineReportFinish'
		|| location.pathname == '/shoho/resend/finish'
	) {
		$(document).ready(function() {
			//コピー用
			$('.res-copy-area').focus(function(){
				$(this).select();
			})
			.click(function(){
				$(this).select();
				return false;
			});
		});
	}

// ===================
// 多重POST防止
// ===================
	// anchor
	$('.res-send-button a').removeClass('disabled');
	$('.res-send-button a').on('click', function() {
		$(this).addClass('disabled');

		$('.res-send-button .res-back a.disabled').on('click', function() {
			return false;
		});
	});

	// input
	$('.res-send-button .reserve-popup-send input').prop('disabled', false);
	if (location.pathname == '/shoho/resend/confirm') {
		$('.res-send-button .reserve-popup-send input').on('click', function() {
			$(this).prop('disabled', true);
		});
	}

	// popup
	$('li.res-popup-ok-btn #sendOk').removeClass('disabled');
	$('li.res-popup-ok-btn #sendOk').on('click', function() {
		if($(this).hasClass('disabled')) return false;
		$(this).addClass('disabled');

		//#15894 イベントの追加
		dataLayer.push({'event': 'formnext','action': '予約フォーム内ボタン','category': 1,'label': EPK.Shoho.ARG.pharmacyId});
		dataLayer.push({'event': 'gtm.linkClick'});

		if (EPK.Shoho.ARG.progresUrl) {
			location.href = EPK.Shoho.ARG.progresUrl;
		}

	});


	//safari ブラウザバック対応
	var pageState = document.getElementsByClassName('res-active');
	if (pageState.length > 0) {
		history.replaceState(null, pageState[0].innerHTML, null);

		window.addEventListener('popstate', function() {
			var submitBtn = document.getElementById('confirm-btn');
			var btnState = submitBtn.hasAttribute('disabled')
			if (submitBtn && btnState) {
				submitBtn.removeAttribute('disabled');
			}
		}, false);
	}

	// submit btn
	$('#confirm-btn').on('click', function() {
		if ($(this).prop('disabled')) {
			return;
		} else if ($(this).hasClass('is-popup')) {
			return;
		}

		$(this).prop('disabled', true);

		dataLayer.push({'event': 'formnext','action': '予約フォーム内ボタン','category': 1,'label': EPK.Shoho.ARG.pharmacyId});
		$('#form-input').submit();
	});

	if (location.pathname == '/shoho/prescription') {
		if ($('.patientselect-box:visible').length >= 3) {
			$('.patientadd-btn').hide();
		}

		if ($('#shown_thumbnail_images_count').length > 0) {
			shownThumbnailImagesCounter.updateShownImagesCount();

			var FileUploader = new EPK.Shoho.FileUploader(pharmacyId);
		}
		$('[id^=patientdel-btn]').on('click', function() {
			EPK.Shoho.Family.deletePatient(EPK.Shoho.ARG['pharmacyId'], $(this).data('person-type'));
		});

		if (EPK.common.isLogin){
			EPK.Shoho.Family.imageCheck();
		}
		if (EPK.Shoho.FileUploader.prototype.countStyleDisp()){
			EPK.Shoho.FileUploader.prototype.changeBtnProp(false);
		}else{
			EPK.Shoho.FileUploader.prototype.changeBtnProp(true);				
		}
	}
// ===================
// 多重POST防止
// ===================

	if ($('.techo-rel').length > 0) {
		var MedicineReport = new EPK.Shoho.MedicineReport(mUserDetailList, medicineReportShopId, medicineReportReserveBundleId);
	}
	
	$("#patientadd-btn").on("click",function(event){
		EPK.Shoho.Family.addFamily();
	});
		
});
